<template>
  <div class="about">
    <post-back :title="content[lang].title" />
    <div class="padding-60">
      <div class="container" v-html="content[lang].text"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "about",
  async mounted() {
    let res = await this.$http.get(
      "content/posts?_id=5e5e44ed32dce822e3cb8bdf"
    );
    console.log(res);

    this.content = res.body.post.content;
  },
  computed: {
    seo() {
      return { title: this.trRaw.about_iwep };
    },
    scontent() {
      let find = this.$store.state.posts.list.find(
        p => p._id == "5e5e44ed32dce822e3cb8bdf"
      );
      console.log(find);
      return find;
    }
  },
  data() {
    return {
      content: {}
    };
  }
};
</script>
<style lang="css" scoped>
.about .container,
.about .container * {
  font-family: "Merriweather", serif !important;
  line-height: 1.5;
}

iframe {
  overflow: hidden;
}
</style>